import {h, Fragment} from "preact"
import SortCustomDropdown from "./SortCustomDropdown"
import SortSelect from "./SortSelect"

export default function Toolbar({ gridView, handleGridViewChange }) {

    return (
        <div class="ns-toolbar ns-w-100 ns-sticky ns-flex ns-flex-col">
            <div class="ns-toolbar-inner ns-flex ns-flex-nowrap ns-items-center ns-justify-between ns-lg-justify-end">
                <div class="ns-grid-controls ns-flex ns-flex-nowrap ns-items-center" role="group" aria-label="Layout options">
                    <button 
                        className="ns-grid-toggle ns-toggle-gallery"
                        onClick={() => handleGridViewChange(-1)} 
                        aria-pressed={gridView === -1}
                        aria-label="Set to gallery layout"
                    >
                        <svg aria-hidden="true" role="presentation" width="16.8" height="10.8" viewBox="0 0 14 10" fill="#bac8c3" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0 .5h4v4H0zM0 5.5h4v4H0zM5 .5h4v4H5zM5 5.5h4v4H5zM10 .5h4v4h-4zM10 5.5h4v4h-4z"></path>
                        </svg>
                    </button>

                    <button
                        className="ns-grid-toggle ns-toggle-compact ns-hidden ns-lg-block"
                        onClick={() => handleGridViewChange(4)} 
                        aria-pressed={gridView === 4}
                        aria-label="Set to 4 column layout"
                    >
                        <svg aria-hidden="true" role="presentation" xmlns="http://www.w3.org/2000/svg" width="20.4" height="12" viewBox="0 0 88 58" fill="#bac8c3">
                            <g clip-path="url(#ns-clip-001)"><path d="M20 0H0V58H20V0Z"></path><path d="M43 0H22V58H43V0Z"></path><path d="M45 0H65V58H45V0Z"></path><path d="M88 0H67V58H88V0Z"></path></g>
                            <defs><clipPath id="ns-clip-001"><rect width="88" height="58" fill="white"></rect></clipPath></defs>
                        </svg>
                    </button>

                    <button 
                        className="ns-grid-toggle ns-toggle-normal"
                        onClick={() => handleGridViewChange(2)} 
                        aria-pressed={gridView === 2}
                        aria-label="Set to 2 column layout"
                    >
                        <svg aria-hidden="true" role="presentation" viewBox="0 0 17 10" width="20.4" height="10.8" fill="#bac8c3" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0 .5h8v9H0zM9 .5h8v9H9z"></path>
                        </svg>
                    </button>
                </div>

                {window.innerWidth < 1240 ? (
                    <SortSelect />
                ) : (
                    <SortCustomDropdown />
                )}
            </div>
        </div>
    )
}